(function () {
  'use strict';

  angular
    .module('accapp', ['ngAnimate', 'ngCookies', 'ngTouch', 'ngSanitize', 'ngMessages', 'ngAria', 'ngResource', 'ui.router', 'ui.bootstrap', 'ui.select', 'ui-notification', 'validation.match', 'angular-loading-bar', 'cfp.loadingBar', 'angularPromiseButtons', 'betsol.intlTelInput', 'ngFileUpload', 'ngImgCrop', 'nickel.minStrength']);

})();

(function () {
  'use strict';

  angular.module('accapp').controller('UploadImageModalController', UploadImageModalController);

  UploadImageModalController.$inject = ['$uibModalInstance', '$scope', '$http', '$filter', '$window', '$timeout', 'Notification', 'Upload'];

  /* @ngInject */
  function UploadImageModalController($uibModalInstance, $scope, $http, $filter, $window, $timeout, Notification, Upload) {
    /* jshint validthis: true */
    var vm = this;

    vm.cancel = cancel;
    vm.ok = ok;

    vm.removeFile = removeFile;

    vm.upload = function (dataUrl, name) {
      
      Upload.upload({
        url: 'https://localhost:44392/api/FileHandler?objectContext=C5F260DD3787',
        data: {
          file: Upload.dataUrltoBlob(dataUrl, name)
        },
      }).then(function (response) {
        $timeout(function () {

          $scope.result = response.data;
          $uibModalInstance.close(response.data.files[0].url);

        });
      }, function (response) {
        if (response.status > 0)
          $scope.errorMsg = response.status + ': ' + response.data;
        else
          Notification.error('Unable to reach file server');
      }, function (evt) {
        $scope.progress = parseInt(100.0 * evt.loaded / evt.total);
      });
    }

    vm.removeFile

    function removeFile() {
      $scope.picFile = undefined;
      vm.enabledZone = true;
    }



    function cancel() {
      $uibModalInstance.dismiss();
    }

    function ok() {
      $uibModalInstance.close(vm.myCroppedImage);
    }


  }
})();

(function () {
    'use strict';

    angular.module('accapp').controller('ConfirmModalCtrl', ConfirmModalCtrl);

    ConfirmModalCtrl.$inject = ['$uibModalInstance', 'data'];

    /* @ngInject */
    function ConfirmModalCtrl($uibModalInstance, data) {
        /* jshint validthis: true */
        var vm = this;

        vm.cancel = cancel;
        vm.ok = ok;
        vm.properties = data;

        function cancel() {
            $uibModalInstance.dismiss();
        }

        function ok() {
            $uibModalInstance.close();
        }
    }
})();
(function () {
  'use strict';

  angular
    .module('accapp')
    .controller('HeaderController', HeaderController);

  HeaderController.inject = ['$state', '$log', 'ngOidcClient'];

  function HeaderController($state, $log, ngOidcClient) {
    var vm = this;

    vm.userInfo = ngOidcClient.userInfo();

    vm.profilemenu = {
      items: [
        //     {
        //     name: "Home",
        //     state: "root.home"
        // }, 
        {
          name: "My Account",
          state: "root.myaccount"
        }
      ]
    }

    activate();
    ////////////////

    function activate() {

    }
  }
})();

(function () {
  'use strict';

  angular
    .module('accapp')
    .directive('wcUnique', wcUnique);

  wcUnique.inject = ['$timeout', '$q', 'BsIdSrv', '$http', '$log'];

  function wcUnique($timeout, $q, BsIdSrv, $http, $log) {
    // Usage:
    //
    // Creates:
    //
    var directive = {
      require: 'ngModel',
      link: link,
      restrict: 'A',
      // controller: ControllerController,
      // controllerAs: 'vm',
    };
    return directive;

    function link(scope, element, attrs, ngModel) {
      ngModel.$asyncValidators.unique = function (value) {
        var deferred = $q.defer();
        if (value) {
          $http.post(BsIdSrv.api + '/Account/checkUnique' + '?username=' + escape(value))
            .then(
              function (result) {
                if (result.data.status) {
                  deferred.resolve(); //It's unique
                } else {
                  deferred.reject(); //Add unique to $errors
                }
              });
        } else {
          deferred.resolve()
        }

        return deferred.promise;

      };
    }
  }
})();

(function () {
    'use strict';

    angular
        .module('accapp')
        .filter('currentDate', currentDate);

    function currentDate($filter) {
        return currentDateFilter;

        ////////////////

        function currentDateFilter() {
            return $filter('date')(new Date(), 'yyyy-MM-dd');
        }
    }
})();
(function () {
  'use strict';

  angular
    .module('accapp')
    .controller('LinkAccountModalController', LinkAccountModalController);

  LinkAccountModalController.inject = ['$rootScope', '$log', '$http', '$uibModalInstance', 'BsIdSrv', 'ngOidcClient', 'Notification', 'BsAccountService'];

  function LinkAccountModalController($rootScope, $log, $http, $uibModalInstance, BsIdSrv, ngOidcClient, Notification, BsAccountService) {
    var vm = this;

    vm.activeTab = 1;

    vm.bsAccounts = [];

    vm.cancel = cancel;
    
    // vm.next = next;
    vm.back = back;

    vm.stepOneNext = stepOneNext;
    vm.stepTwoNext = stepTwoNext;
    vm.stepThreeSubmit = stepThreeSubmit;

    vm.toogleCheckBox = toogleCheckBox;

    vm.anyOfType = anyOfType;

    function anyOfType(collection, type) {
      var any = false;
      if (collection) {
        collection.forEach(function (element) {
          if (element.type == type) {
            any = true;
            // break;
          }
        }, this);
      }
      return any;
    }



    activate();

    ////////////////

    function activate() {}

    function cancel() {
      $uibModalInstance.dismiss();
    }

    function stepThreeSubmit() {
      BsAccountService.addBsAccounts(vm.selectedBsAccounts, vm.password).then(function () {
        ngOidcClient.signinSilent().then(function (user) {
          $uibModalInstance.close(vm.bsAccounts);
        });
      })
    }

    function stepOneNext(valid) {
      if (valid) {
        vm.stepOnePromise = findAccount(vm.id, vm.password).then(function (data) {
          vm.bsAccounts = _.clone(data, true);
          vm.selectedBsAccounts = _.clone(data, true);
          if (vm.selectedBsAccounts.length == 0) {
            vm.selectedBsAccounts.$error = {
              'not-found': true
            }
          }

          vm.activeTab++;
        }, function (error) {

        });
      }
    }

    function stepTwoNext() {
      if (vm.activeTab == 2 && vm.selectedBsAccounts.length) {
        vm.activeTab++;
      }


    }

    function toogleCheckBox(account) {
      if (account.selected) {
        vm.selectedBsAccounts.push(account);
        vm.selectedBsAccounts.$error = {
          'required': false
        }
      } else {
        _.remove(vm.selectedBsAccounts, {
          id: account.id
        });
        if (vm.selectedBsAccounts == 0)
          vm.selectedBsAccounts.$error = {
            'required': true
          }
      }
      // account.selected ? group.selectedTotal = group.selectedTotal + 1 : group.selectedTotal = group.selectedTotal - 1
    }

    // function next() {
    //   if (vm.activeTab == 2)
    //     vm.activeTab++;
    //   if (vm.activeTab < 3) {
    //     if (vm.activeTab == 1) {
    //       findAccount(vm.id, vm.password).then(function (data) {
    //         $log.info(data);
    //         if (data.length == 0) {
    //           Notification.error('Account not found');
    //           vm.password = '';
    //         } else {
    //           vm.bsAccounts = data;
    //           vm.activeTab++;
    //           // vm.accounts = data;
    //         }
    //       })
    //     }
    //   }
    // }

    function back() {
      if (vm.activeTab > 1)
        vm.activeTab--;
    }

    // function groupByType() {
    //   vm.groups = _.chain(vm.bsAccounts)
    //     .groupBy("type")
    //     .toPairs()
    //     .map(function (currentItem) {
    //       return _.fromPairs(_.zip(["type", "accounts"], currentItem));
    //     })
    //     .value();
    //  BsIdSrv.api + "/Account/:id"
    // }

    function findAccount(id, password) {
      var url = BsIdSrv.api + '/account/find';
      return $http.post(url, {
        id: id,
        password: password,
      }).then(function (response) {
        return response.data;
      });

    }

    $rootScope.$on('cfpLoadingBar:started', function () {
      vm.waiting = true;
    });

    $rootScope.$on('cfpLoadingBar:completed', function () {
      vm.waiting = false;
    });
  }
})();

(function (module) {

  var requestCounter = function ($q) {

    var requests = 0;

    var request = function (config) {
      requests += 1;
      return $q.when(config);
    };

    var requestError = function (error) {
      requests -= 1;
      return $q.reject(error);
    };

    var response = function (response) {
      requests -= 1;
      return $q.when(response);
    };

    var responseError = function (error) {
      requests -= 1;
      return $q.reject(error);
    };

    var getRequestCount = function () {
      return requests;
    };

    return {
      request: request,
      response: response,
      requestError: requestError,
      responseError: responseError,
      getRequestCount: getRequestCount
    };

  };

  module.factory("requestCounter", requestCounter);

}(angular.module("accapp")));

(function () {
  'use strict';

  angular.module('accapp').factory('dialogsService', dialogsService);

  dialogsService.$inject = ['$uibModal'];

  function dialogsService($uibModal) {
    var service = {
      confirm: confirm,
      addAccount: addAccount,
      uploadImage: uploadImage
    };

    return service;

    function confirm(message, title, buttons) {
      var modalInstance = $uibModal.open({
        templateUrl: 'app/shared/modals/confirmModal/confirm-modal.html',
        controller: 'ConfirmModalCtrl',
        controllerAs: 'vm',

        resolve: {
          data: function () {
            return {
              message: message,
              title: title,
              buttons: buttons
            };
          }
        },
        size: 'sm'
      });

      return modalInstance.result;
    }

    function addAccount() {
      var modalInstance = $uibModal.open({
        templateUrl: 'app/account/link-account-modal/link-account-modal.html',
        controller: 'LinkAccountModalController',
        controllerAs: 'vm',
        // size: 'lg',
        backdrop: 'static',
        keyboard: false
      });

      return modalInstance.result;
    }

    function uploadImage() {
      var modalInstance = $uibModal.open({
        templateUrl: 'app/shared/modals/uploadImageModal/upload-image-modal.html',
        controller: 'UploadImageModalController',
        controllerAs: 'uploadCtrl',
        size: 'lg',
      });

      return modalInstance.result;
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('accapp')
    .service('BsAccountService', BsAccountService);

  BsAccountService.inject = ['$log', '$http', 'BsIdSrv'];

  function BsAccountService($log, $http, BsIdSrv) {
    var service = {
      addBsAccounts: addBsAccounts
    };

    var url = BsIdSrv.api + '/account/addbsaccounts';

    function BsAccount(id, name, type, level) {
      this.id = id;
      this.name = name;
      this.type = type;
      this.level = level;
    }



    return service;
    ////////////////

    function addBsAccounts(bsAccounts, password) {
      return $http.post(url, {
        bsAccounts: bsAccounts,
        password: password
      }).then(function (response) {
        return response.data;
      }, function (error) {
        $log.error(error);
      })
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('accapp')
    .provider('ngOidcClient', ['BsIdSrv', NgOidcClientProvider]);

  /** @ngInject */
  function NgOidcClientProvider(BsIdSrv) {
    this.settings = null;
    this.mgr = null;
    this.userInfo = {
      user: null,
      isAuthenticated: false
    };
    this.urls = [];
    this.$get.$inject = ['$q', '$log', '$rootScope'];



    var x = JSON.parse(localStorage.getItem('oidc.user:' + BsIdSrv.core + ':uirouterClient'));
    if (x) {
      this.userInfo.user = x;
      this.userInfo.isAuthenticated = true;
    }


  }

  NgOidcClientProvider.prototype.setSettings = function (options) {
    this.settings = options;

  }

  NgOidcClientProvider.prototype.$get = function ($q, $log, $rootScope) {
    var _this = this;
    $log.debug("NgOidcClient service started");

    if (!this.settings)
      throw Error('NgOidcUserService: Must call setSettings() with the required options.');

    Oidc.Log.logger = $log;
    // Oidc.Log.level = Oidc.Log.INFO;
    Oidc.Log.level = Oidc.Log.ERROR;

    this.mgr = new Oidc.UserManager(this.settings);

    this.mgr.getUser().then(function (user) {
      if (user !== null) {
        _this.userInfo.user = user;
        _this.userInfo.isAuthenticated = true;
        notifyUserInfoChangedEvent();
      }
    })

    this.mgr.events.addUserLoaded(function (u) {
      _this.userInfo.user = u;
      _this.userInfo.isAuthenticated = true;
      $log.debug("user loaded");
      notifyUserInfoChangedEvent();
    });

    this.mgr.events.addUserSignedOut(function (u) {
      _this.userInfo.user = null;
      _this.userInfo.isAuthenticated = false;
      $log.log("user signedOut");
      notifyUserInfoChangedEvent();
    });

    var notifyUserInfoChangedEvent = function () {
      $rootScope.$emit('ng-oidcclient-userinfo-changed-event');
    };

    var signinRedirect = function (args) {
      return _this.mgr.signinRedirect(args);
    };

    var signinRedirecCallback = function (args) {
      return _this.mgr.signinRedirectCallback()
        .then(function (user) {
          $log.log("signin response success", user);
          return user;
        })
        .catch(function (err) {
          $log.log(err);
        });
    };

    var signoutRedirect = function (args) {
      return _this.mgr.signoutRedirect(args);
    };

    var signinSilentCallback = function () {
      _this.mgr.signinSilentCallback().then(function (user) {
        $log.debug(user);
      }).catch(function (err) {
        $log.error(err);
      });
    };

    var signinSilent = function () {
      return _this.mgr.signinSilent().then(function (user) {
        return user;
      }).catch(function (err) {
        $log.error(err);
      });
    };


    var userInfoChanged = function (scope, callback) {
      var handler = $rootScope.$on('ng-oidcclient-userinfo-changed-event', callback);
      scope.$on('$destroy', handler);
    };

    var userInfo = function () {
      return _this.userInfo;
    };
    var getUserInfo = function () {
      return _this.mgr.getUser().then(function (user) {
        if (user !== null) {
          _this.userInfo.user = user;
          _this.userInfo.isAuthenticated = true;
          notifyUserInfoChangedEvent();
          return _this.userInfo;
        }
      })
    }
    var signoutPopup = function (args) {
      return _this.mgr.signoutPopup(args);
    };

    var getUser = function () {
      return _this.mgr.getUser();
    }

    return {
      getUser: getUser,
      userInfo: userInfo,
      getUserInfo: getUserInfo,
      signoutPopup: signoutPopup,
      signinSilent: signinSilent,
      signinRedirect: signinRedirect,
      signinRedirecCallback: signinRedirecCallback,
      signoutRedirect: signoutRedirect,
      signinSilentCallback: signinSilentCallback,
      userInfoChanged: userInfoChanged
    };
  }

})();

(function () {
  'use strict';

  angular
    .module('accapp')
    .factory('addToken', addToken);

  addToken.inject = ['ngOidcClient', '$q', '$injector'];

  function addToken(ngOidcClient, $q, $injector) {
    var service = {
      request: request,
      responseError: responseError
    };

    return service;

    ////////////////
    function request(config) {
      //var AccountService = $injector.get('AccountService');
      var userInfo = ngOidcClient.userInfo();

      if (userInfo.isAuthenticated) {
        config.headers.Authorization = "Bearer " + userInfo.user.access_token;
      }

      return $q.when(config)
    }

    function responseError(rejection) {
      if (!rejection || !rejection.status) {
        $log.error('Broken interceptor detected');
        return $q.reject(rejection);
      }

      if (rejection.status == 401) {
        var $state = $injector.get('$state');
        $state.go('login');
      }
      return $q.reject(rejection);
    }
  }
})();

(function () {
    'use strict';

    angular
        .module('accapp')
        .service('AccountService', AccountService);

    AccountService.inject = ['$resource', 'BsIdSrv'];
    function AccountService($resource, BsIdSrv) {
        this.account = account;

        ////////////////

        function account() {
            var _account = $resource(BsIdSrv.api + "/Account/:id",
                {
                    id: "@id"
                },
                {
                    'update': {
                        method: 'PUT'
                    }
                });

            return _account;

        }
    }
})();
(function () {
  'use strict';

  angular
    .module('accapp')
    .controller('RootController', RootController);

  /** @ngInject */
  function RootController($scope, $state, ngOidcClient) {
    var vm = this;



    //vm.userInfo = userInfo;

    function Mycallback() {
      vm.userInfo = ngOidcClient.userInfo();
      if ($state.current.name != 'root.resetpassword' && $state.current.name != 'root.forgotpassword' && !vm.userInfo.isAuthenticated)
        $state.go('login');
      $scope.$apply();
    }
    ngOidcClient.userInfoChanged($scope, Mycallback);

    activate();

    function activate() {
      ngOidcClient.getUserInfo();

    }


  }
})();

(function () {
    'use strict';

    angular
        .module('accapp')
        .controller('ProfileController', ProfileController);

    /** @ngInject */
    function ProfileController() {
        var vm = this;


        activate();

        function activate() {
          
        }

     
    }
})();

(function() {
  'use strict';

  angular
    .module('accapp')
      .controller('HomeController', HomeController);
       /** @ngInject */
       
       function HomeController($timeout, $state, $log, ngOidcClient, $scope) {
         var vm = this;
         
         vm.awesomeThings = [];
         vm.classAnimation = '';

         activate();

         function activate() {
             $log.debug($state.current.data);
             getWebDevTec();
             $timeout(function() {
                     vm.classAnimation = 'rubberBand';
                 },
                 4000);
         }

        function Mycallback(){
            vm.userInfo = ngOidcClient.userInfo();
            $scope.$apply()
        }

        ngOidcClient.userInfoChanged($scope, Mycallback);

        function showToastr() {
        toastr.info('Fork <a href="https://github.com/Swiip/generator-gulp-angular" target="_blank"><b>generator-gulp-angular</b></a>');
        vm.classAnimation = '';
      }

      function getWebDevTec() {
        vm.awesomeThings =  []

        angular.forEach(vm.awesomeThings, function(awesomeThing) {
          awesomeThing.rank = Math.random();
        });
      }
  }
})();

(function () {
    'use strict';

    angular
        .module('accapp')
        .controller('HelpController', HelpController);

    /** @ngInject */
    function HelpController($rootScope) {
        var vm = this;

        vm.toggleSidebar = toggleSidebar;


        activate();

        function activate() {
          
        }

        function toggleSidebar(){
            $rootScope.toggleSidebar = !$rootScope.toggleSidebar;
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('accapp')
        .controller('LoginController', LoginController);

    LoginController.inject = ['ngOidcClient', '$log', '$stateParams'];
    function LoginController(ngOidcClient, $log, $state, $stateParams) {

        activate();

        ////////////////

        function activate() {
            $log.debug($stateParams.toState);
            ngOidcClient.signinRedirect({state : $stateParams.toState});
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('accapp')
        .controller('SilentCallbackController', SilentCallbackController);

    SilentCallbackController.inject = ['ngOidcClient', '$log', '$state'];
    function SilentCallbackController(ngOidcClient, $log, $state) {
        var vm = this;


        activate();

        /////////////////

        function activate() {
            ngOidcClient.signinSilentCallback();
        }
    }
})();
(function () {
  'use strict';

  angular
    .module('accapp')
    .controller('AuthCallbackController', AuthCallbackController);

  AuthCallbackController.inject = ['ngOidcClient', '$log', '$state', '$rootScope'];

  function AuthCallbackController(ngOidcClient, $log, $state, $rootScope) {
    var vm = this;
    activate();

    ////////////////

    function activate() {
      ngOidcClient.signinRedirecCallback().then(function (result) {
        if (result) {
          var state = {};
          var x = result.state.split('?');
          state.name = x[0];
          if (x.length > 1) {
            state.params = {};
            var y = x[1].split('=');
            state.params[y[0]] = y[1];
            $state.go(state.name, state.params);
          } else
            $state.go(state.name);
        } else
          $state.go('root.home');
      }, function (err) {
        $log.error(err);
      });
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('accapp')
    .controller('SignupDoneController', SignUpDoneController);

  SignUpDoneController.inject = ['$stateParams', 'BsIdSrv'];

  function SignUpDoneController($stateParams, BsIdSrv) {
    var vm = this;

    vm.email = $stateParams.email;

    vm.redirecUrl = BsIdSrv.ui + "/myaccount";

    if ($stateParams.signin)
      vm.redirecUrl = BsIdSrv.core + "/login?signin=" + $stateParams.signin;

    activate();

    ////////////////

    function activate() {}
  }
})();

(function () {
  'use strict';

  angular
    .module('accapp')
    .controller('SignupController', SignupController);

  SignupController.inject = ['$log', '$state', '$stateParams', 'AccountService', 'Notification'];

  function SignupController($log, $state, $stateParams, AccountService, Notification) {
    var vm = this;

    vm.emailFormat = /^[a-zA-Z]+[a-zA-Z0-9._]+@[a-zA-Z]+\.[a-zA-Z.]{2,10}$/;

    vm.months = [{
        id: 1,
        name: 'January'
      },
      {
        id: 2,
        name: 'February'
      },
      {
        id: 3,
        name: 'March'
      },
      {
        id: 4,
        name: 'April'
      },
      {
        id: 5,
        name: 'May'
      },
      {
        id: 6,
        name: 'June'
      },
      {
        id: 7,
        name: 'July'
      },
      {
        id: 8,
        name: 'August'
      },
      {
        id: 9,
        name: 'September'
      },
      {
        id: 10,
        name: 'October'
      },
      {
        id: 11,
        name: 'November'
      },
      {
        id: 12,
        name: 'December'
      }
    ];

    vm.genders = [{
        value: 'female',
        name: 'Female'
      },
      {
        value: 'male',
        name: 'Male'
      },
      {
        value: 'other',
        name: 'Other'
      },
      {
        value: null,
        name: 'Rather not say'
      }
    ];

    vm.signupForm = {
      name: "",
      lastName: "",
      password: "",
      confirmPassword: "",
      birthdateMonth: null,
      birthdateDay: null,
      birthdateYear: null,
      birthdate: null,
      gender: "",
      mobile: "",
      email: "",
      confirmEmail: ""
    }

    vm.submitSignupForm = submitSignupForm;

    activate();

    ////////////////

    function activate() {
      vm.years = [];
      var maxYear = 2017;
      var maxAge = 90;
      var minAge = 16;
      for (var i = maxYear - minAge; i > maxYear - maxAge; i--) {
        vm.years.push(i);
      }
    }

    function submitSignupForm(isValid) {
      if (isValid) {
        var d = new Date(vm.signupForm.birthdateYear, vm.signupForm.birthdateMonth, vm.signupForm.birthdateDay);
        vm.signupForm.birthdate = d;
        vm.signupForm.email = vm.signupForm.email.toLowerCase();
        vm.signupForm.confirmEmail = vm.signupForm.confirmEmail.toLowerCase();
        $log.debug(vm.signupForm);
        AccountService.account().save(vm.signupForm, function (result) {
          $log.debug(result);
          $state.go('root.signupdone', {
            signin: $stateParams.signin,
            email: result.email
          });
        }, function (error) {
          Notification.error(error.data.message);
          vm.signupForm.password = "";
          vm.signupForm.confirmPassword = "";
          $log.error(error);
        });
      }
    }
  }
})();

(function() {
'use strict';

    angular
        .module('accapp')
        .controller('ResetPasswordEmailSentController', ResetPasswordEmailSentController);

    ResetPasswordEmailSentController.inject = ['$log','$stateParams'];
    function ResetPasswordEmailSentController($log, $stateParams) {
        var vm = this;

        vm.email = $stateParams.email;
        

        activate();

        ////////////////

        function activate() { }
    }
})();
(function () {
  'use strict';

  angular
    .module('accapp')
    .controller('ResetPasswordController', ResetPasswordController);

  ResetPasswordController.inject = ['$log', '$state', '$stateParams', 'BsIdSrv', '$http', 'Notification'];

  function ResetPasswordController($log, $state, $stateParams, BsIdSrv, $http, Notification) {
    var vm = this;
    vm.title = "ResetPasswordController";

    vm.userId = $stateParams.uid;
    vm.token = $stateParams.code;

    vm.resetPasswordForm = {
      password: "",
      confirmPassword: ""
    }


    vm.reset = reset;

    activate();

    ////////////////

    function activate() {}

    function reset(isValid) {
      if (isValid) {
        var encoredCode = encodeURIComponent($stateParams.code);
        var url = BsIdSrv.api + '/account/resetpassword?uid=' + $stateParams.uid + '&code=' + encoredCode;
        //var encoredUrl = encodeURI(url);

        $http.post(url, {
          password: vm.resetPasswordForm.password,
          confirmPassword: vm.resetPasswordForm.confirmPassword
        }).then(function (result) {
          $log.debug(result);
          $state.go('root.passwordchanged');

        }, function (error) {
          if (error.status == 401) {
            Notification.error("Token expired.");
            $state.go('root.forgotpassword');
          }

          if (error.status == 404)
            Notification.error("User not found.");



          $log.error(error);
        });
      }

    }
  }
})();

(function () {
  'use strict';

  angular
    .module('accapp')
    .controller('MyAccountController', MyAccountController);

  MyAccountController.inject = ['ngOidcClient', '$log', '$scope', '$q', '$rootScope', '$stateParams', 'BsIdSrv', '$http', 'Notification', 'cfpLoadingBar', 'AccountService', 'dialogsService', 'userInfo', '$window', 'VirtualOffice'];

  function MyAccountController(ngOidcClient, $log, $scope, $q, $rootScope, $stateParams, BsIdSrv, $http, Notification, cfpLoadingBar, AccountService, dialogsService, userInfo, $window, VirtualOffice) {
    var vm = this;

    vm.accounts = [];
    vm.userInfo = ngOidcClient.userInfo();
    vm.return = $stateParams.return;

    // Settings
    vm.update = update;
    vm.changePicture = changePicture;
    // vm.busy = false;

    vm.settings = {
      name: "",
      familyName: "",
      birthdate: "",
      gender: "",
      preferredUsername: ""
      // phoneNumber: "",
      // email: ""
    }

    // Accounts
    vm.accountTypes = [
      //  {
      //     id: "auto",
      //     name: 'Auto Detect'
      // },
      {
        id: "prepaid",
        name: 'Prepaid'
      },
      {
        id: "merchantService",
        name: 'Merchant Service'
      },
      {
        id: "callingCard",
        name: 'Calling Card'
      },
    ];

    vm.accordionExpanded = true;
    vm.toggleExpand = toggleExpand;

    vm.deleteItem = deleteItem;
    vm.addAccount = addAccount;
    vm.setDefaultItem = setDefaultItem;

    activate();

    ////////////////

    function activate() {
      setSettings();

      getAccounts();

      if (vm.accounts.length == 0)
        addAccount();

      initializeGroups();
      toggleExpand(vm.accordionExpanded);

    }

    function setSettings() {
      vm.settings = {
        name: vm.userInfo.user.profile.name,
        familyName: vm.userInfo.user.profile.family_name,
        birthdate: vm.userInfo.user.profile.birthdate,
        gender: vm.userInfo.user.profile.gender,
        preferredUsername: vm.userInfo.user.profile.preferred_username,
        phoneNumber: vm.userInfo.user.profile.phone_number,
        email: vm.userInfo.user.profile.email
      };
    }

    // Accounts
    function getAccounts() {
      var paccounts = getBsAccount(vm.userInfo.user.profile.bs_account_prepaid, "Prepaid");
      var msaccounts = getBsAccount(vm.userInfo.user.profile.bs_account_merchantservice, "MerchantService");
      var ccaccounts = getBsAccount(vm.userInfo.user.profile.bs_account_callingcard, "CallingCard");
      vm.accounts = vm.accounts.concat(paccounts);
      vm.accounts = vm.accounts.concat(msaccounts);
      vm.accounts = vm.accounts.concat(ccaccounts);
    }

    function setDefaultItem(group, account) {

      var url = BsIdSrv.api + '/account/setdefaultbsaccount?id=' + vm.userInfo.user.profile.sub;
      var data = {
        number: account.accountId,
        password: "",
        type: group.type
      };

      return $http.post(url, data).then(function (result) {
        refresh();
      }, function (error) {
        $log.error(error);
      });
    }

    function deleteItem(group, account) {
      dialogsService.confirm('Are you sure you want to Delete this item?', 'Delete?', ['OK', 'Cancel'])
        .then(function () {
          var url = BsIdSrv.api + '/account/removebsaccount?id=' + vm.userInfo.user.profile.sub;
          var data = {
            number: account.accountId,
            password: "",
            type: group.type
          };
          $http.post(url, data).then(function (result) {
            refresh();
          }, function (error) {
            $log.error(error);
            vm.addAccountForm.password = "";
          })
        });
    }

    function refresh() {
      cfpLoadingBar.start();
      return ngOidcClient.signinSilent().then(function (user) {
        vm.userInfo = ngOidcClient.userInfo();
        $log.debug(user);
        refreshBsAccounts();
        setSettings();
        $scope.$apply();
        cfpLoadingBar.complete();
        return true;
      });
    }

    function refreshBsAccounts() {
      cfpLoadingBar.start();
      getAccounts();
      initializeGroups();
      toggleExpand(vm.accordionExpanded);
      cfpLoadingBar.complete();
    }



    function addAccount() {
      dialogsService.addAccount().then(function (response) {
        refresh().then(function (success) {
          if (success && vm.return)
            switch (vm.return) {
              case 'virtualoffice':
                $window.location.replace(VirtualOffice.ui);
                break;
              default:
                return;
            }

        });
      })
    }

    function getBsAccount(accounts, type) {
      var result = [];
      if (accounts === undefined)
        return result;
      if (Array.isArray(accounts)) {
        _.forEach(accounts, function (account) {
          var x = {
            accountId: "",
            type: "",
            isDefault: false
          };
          if (type == "Prepaid") {
            if (vm.userInfo.user.profile.bs_account_prepaid_default == account)
              x.isDefault = true;
          }

          x.accountId = account;
          x.type = type;
          result.push(x);
        });

      } else {
        var x = {
          accountId: "",
          type: "",
          isDefault: false
        };
        switch (type) {
          case "Prepaid":
            if (vm.userInfo.user.profile.bs_account_prepaid_default == accounts)
              x.isDefault = true;
            break;
          case "MerchantService":
            if (vm.userInfo.user.profile.bs_account_merchantservice_default == accounts)
              x.isDefault = true;
          case "CallingCard":
            if (vm.userInfo.user.profile.bs_account_callingcard_default == accounts)
              x.isDefault = true;
            break;
          default:
            x.isDefault = false;
        }
        x.accountId = accounts;
        x.type = type;
        result.push(x);
      }

      return result;
    }

    function toggleExpand(expand) {
      _.forEach(vm.groups, function (group) {
        group.isOpen = expand;
      });
    }

    function initializeGroups() {
      vm.groups = _.chain(vm.accounts)
        .groupBy("type")
        .toPairs()
        .map(function (currentItem) {
          return _.fromPairs(_.zip(["type", "accounts"], currentItem));
        })
        .value();
    }

    //Settings
    function update(valid) {
      if (valid) {
        $http.put(BsIdSrv.api + "/account?id=" + vm.userInfo.user.profile.sub, vm.settings).then(function (response) {
            debugger;
            $log.debug(response);
          })
          .catch(function (error) {
            $log.error(error);

          })
      }
    }

    function changePicture() {
      dialogsService.uploadImage().then(function (result) {
        // upload image and get url
        $http.post(BsIdSrv.api + '/account/profilepicupdate', {
          url: result
        }).then(function (response) {
          refresh();
        })

        // update profile picture image claim

        // refresh
      })

    }

  }
})();

(function () {
  'use strict';

  angular
    .module('accapp')
    .controller('ForgotPasswordController', ForgotPasswordController);

  ForgotPasswordController.inject = ['$log', '$http', '$state', 'BsIdSrv'];

  function ForgotPasswordController($log, $http, $state, BsIdSrv) {
    var vm = this;

    debugger;

    vm.title = "ForgotPasswordController";

    vm.nextStep = nextStep;
    vm.email = "";

    activate();

    ////////////////

    function activate() {

    }

    function nextStep(isValid) {
      if (isValid) {
        var encodedEmail = encodeURIComponent(vm.email);
        var url = BsIdSrv.api + '/account/resetpasswordemail';

        $http.post(url, {
          email: vm.email
        }).then(function (result) {
          $log.debug(result);
          $state.go('root.resetpasswordemailsent', {
            email: vm.email
          });

        }, function (error) {

          $log.error(error);
        });

      }


    }
  }
})();

(function () {
  'use strict';

  angular
    .module('accapp')
    .controller('ConfirmEmailController', ConfirmEmailController);

  ConfirmEmailController.inject = ['$stateParams', '$log', '$http'];

  function ConfirmEmailController($stateParams, $log, $http, valid) {
    var vm = this;
    vm.title = "";
    vm.subTitle = "";

    if (valid.status == 200) {
      vm.valid = true;
      vm.title = "Email Confirmed.";
      vm.subTitle = "Your account is activated and ready.";

    } else {
      vm.title = "";
      vm.subTitle = "";
      vm.valid = false;
    }


    activate();

    ////////////////

    function activate() {

    }

    // function confirmEmail() {
    //   var encoredCode = encodeURI($stateParams.code);
    //   var url = 'https://localhost:44345/api/account/cofirmemail';
    //   var encoredUrl = encodeURI(url);

    //   $http.post(url, {
    //     uid: $stateParams.uid,
    //     code: $stateParams.code
    //   }).then(function (result) {
    //     $log.info(result);

    //   }, function (error) {

    //     $log.error(error);
    //   });
    // }
  }
})();

(function () {
  'use strict';

  angular
    .module('accapp')
    .run(runBlock);

  /** @ngInject */
  function runBlock($log, $rootScope, $state, ngOidcClient) {

    $log.debug('runBlock end');
    $rootScope.$state = $state;
    // $rootScope.toggleSidebar = false;

    $rootScope.$on('$stateChangeSuccess', function (event, toState, toParams, fromState) {
      $state.previous = fromState;
    });

    $rootScope.$on('$stateChangeStart', function (event, toState, toParams) {
      var requireLogin = false;

      if (toState.data)
        requireLogin = toState.data.requireLogin;

      var userInfo = ngOidcClient.userInfo();

      if (requireLogin && !userInfo.isAuthenticated) {
        event.preventDefault();
        if (toState.name != 'login') {
          var state = {
            toState: toState.name
          };
          if (toParams) {
            if (toParams.return)
              state.toState = state.toState + "?return=" + toParams.return;
          }
          $state.go('login', state);
        }
      }

    });
  }

})();

(function () {
  'use strict';

  angular
    .module('accapp')
    .config(routerConfig);

  /** @ngInject */
  function routerConfig($stateProvider, $urlRouterProvider, BsIdSrv) {

    $urlRouterProvider.otherwise('/myaccount');

    $stateProvider
      .state('root', {
        abstract: true,
        views: {
          '': {
            templateUrl: 'app/shared/layout.default.html',
            controller: 'RootController',
            controllerAs: 'root'
          },
          'header@root': {
            templateUrl: 'app/shared/templates/header.tpl.html',
            controller: 'HeaderController',
            controllerAs: 'header'
          },
          'sidebar@root': {
            templateUrl: 'app/shared/templates/sidebar.tpl.html',
          },
          'footer@root': {
            templateUrl: 'app/shared/templates/footer.tpl.html'
          }
        },
        data: {
          requireLogin: false
        }
      })
      // .state('root.home', {
      //   url: '/home',
      //   templateUrl: 'app/home/home.html',
      //   controller: 'HomeController',
      //   controllerAs: 'home',

      // })
      .state('root.signup', {
        url: '/signup?signin',
        templateUrl: 'app/account/signup.html',
        controller: 'SignupController',
        controllerAs: 'signup',

      })
      .state('root.signupdone', {
        url: '/SignUpDone?signin&email',
        templateUrl: 'app/account/signupdone.html',
        controller: 'SignupDoneController',
        controllerAs: 'signupdone',

      })
      .state('root.confirmemail', {
        url: '/confirmEmail?uid&code',
        templateUrl: 'app/account/confirmEmail.html',
        controller: 'ConfirmEmailController',
        controllerAs: 'confirmemail',
        resolve: {
          valid: function ($http, $stateParams, $log) {
            var url = BsIdSrv.api + '/account/cofirmemail';
            return $http.post(url, {
              uid: $stateParams.uid,
              code: $stateParams.code
            })
          }
        }
      })
      .state('root.forgotpassword', {
        url: '/forgotpassword',
        templateUrl: 'app/account/forgotPassword.html',
        controller: 'ForgotPasswordController',
        controllerAs: 'forgotpassword',
      })
      .state('root.resetpasswordemailsent', {
        url: '/resetpasswordemailsent?email',
        templateUrl: 'app/account/resetpasswordemailsent.html',
        controller: 'ResetPasswordEmailSentController',
        controllerAs: 'resetpasswordemailsent',
      })
      .state('root.resetpassword', {
        url: '/resetpassword?uid&code',
        templateUrl: 'app/account/resetPassword.html',
        controller: 'ResetPasswordController',
        controllerAs: 'resetpassword',
      })
      .state('root.passwordchanged', {
        url: '/passwordchanged',
        templateUrl: 'app/account/passwordchanged.html'
      })
      .state('root.myaccount', {
        url: '/myaccount?return',
        templateUrl: 'app/account/myaccount.html',
        controller: 'MyAccountController',
        controllerAs: 'myaccount',
        resolve: {
          userInfo: function (ngOidcClient) {
            return ngOidcClient.getUserInfo();
          }
        },
        data: {
          requireLogin: true
        }
      })
      .state('root.profile', {
        url: '/profile',
        templateUrl: 'app/profile/profile.html',
        controller: 'ProfileController',
        controllerAs: 'profile',
      })
      .state('root.help', {
        url: '/help',
        templateUrl: 'app/help/help.html',
        controller: 'HelpController',
        controllerAs: 'help',
      })

      .state('root.contacts.list', {
        url: '/list',
        templateUrl: 'app/contacts/contacts.list.html'
      })
      .state('root.contacts.detail', {
        url: '/:id',
        templateUrl: 'app/contacts/contacts.details.html',
        controller: function ($scope, $stateParams) {
          var vm = this;
          vm.person = $scope.$parent.contact.contacts[$stateParams.id];
        },
        controllerAs: 'contactDetail'
      })
      .state('login', {
        controller: 'LoginController',
        controllerAs: 'login',
        params: {
          toState: 'root.home'
        }
      })
      .state('singout', {
        url: '/singout',
        controller: function ($state, ngOidcClient) {
          ngOidcClient.signoutRedirect();
        },
        controllerAs: 'signout',

      })
      .state('authCallback', {
        url: '/auth/callback/',
        controller: 'AuthCallbackController',
        controllerAs: 'authCallback',

      })
      .state('authSilentCallback', {
        url: '/auth/silentcallback/',
        controller: 'SilentCallbackController',
        controllerAs: 'authSilentCallback',
      });
  }
})();

(function () {
  'use strict';

  angular
    .module('accapp')
    .filter("accountLevel", function () {
      return function (input) {
        if (input === 1) {
          return "Company Root";
        } else if (input === 2) {
          return "ISO";
        } else if (input === 3) {
          return "Distributor";
        } else if (input === 4) {
          return "Sales Agent";
        } else if (input === 5) {
          return "Merchant";
        } else {
          return "Unknown";
        }
      }
    })
    .filter("accountType", function () {
      return function (input) {
        if (input == 1) {
          return "Prepaid";
        } else if (input == 2) {
          return "Merchant Service";
        } else if (input == 3) {
          return "Calling Card";
        } else {
          return "Unknown";
        }
      }
    })
    .filter("startFrom", function () {
      return function (input, start) {
        if (input) {
          start = +start; //parse to int
          return input.slice(start);
        }
        return [];
      }
    })
})();

/* global malarkey:false, moment:false */
(function () {
  'use strict';

  angular
    .module('accapp')
    .constant('BsIdSrv', {
      core: "https://identity.pinserve.com/core",
      api: "https://idsrvapi.pinserve.com/api",
      ui: "https://accounts.pinserve.com/#"
    })
    .constant('VirtualOffice', {
      ui: "https://virtual.pinserve.com"
    })
  // .constant('BsIdSrv', {
  //   core: "https://localhost:44316/core",
  //   api: "https://localhost:44345/api",
  //   ui: "https://localhost:44384/#"
  // })
  // .constant('VirtualOffice', {
  //   ui: "https://localhost:44385"
  // })
})();

(function () {
  'use strict';

  angular
    .module('accapp')
    .config(config);


  /** @ngInject */
  function config($logProvider, BsIdSrv, ngOidcClientProvider, NotificationProvider, intlTelInputOptions, $httpProvider, $windowProvider, cfpLoadingBarProvider, angularPromiseButtonsProvider) {
    // Enable log
    $logProvider.debugEnabled(true);

    $httpProvider.interceptors.push("addToken");
    $httpProvider.interceptors.push("requestCounter");
    $httpProvider.defaults.headers.common = {};


    cfpLoadingBarProvider.parentSelector = '#loading-bar-container';
    cfpLoadingBarProvider.includeSpinner = true;
    cfpLoadingBarProvider.latencyThreshold = 50;
    cfpLoadingBarProvider.spinnerTemplate = '<div class="overlay"><div id="loading-bar-spinner"><div class="spinner-icon"></div></div></div>';

    ngOidcClientProvider.setSettings({
      authority: BsIdSrv.core,
      client_id: "uirouterClient",
      redirect_uri: $windowProvider.$get().location.protocol + "//" + $windowProvider.$get().location.host + "/#/auth/callback/#",
      post_logout_redirect_uri: $windowProvider.$get().location.protocol + "//" + $windowProvider.$get().location.host + "/#/home",
      silent_redirect_uri: window.location.protocol + "//" + window.location.host + "/#/auth/silentcallback/#",
      popup_redirect_uri: $windowProvider.$get().location.protocol + "//" + $windowProvider.$get().location.host + "/#/",

      response_type: "id_token token",
      scope: "openid profile offline_access phone joindate email bsAccount",

      automaticSilentRenew: true,

      filterProtocolClaims: true,
      loadUserInfo: true,
      userStore: new Oidc.WebStorageStateStore({
        store: $windowProvider.$get().localStorage
      })
    });

    NotificationProvider.setOptions({
      delay: 2000,
      startTop: 80,
      startRight: 10,
      verticalSpacing: 20,
      horizontalSpacing: 20,
      positionX: 'right',
      positionY: 'top'
    });

    angular.extend(intlTelInputOptions, {
      nationalMode: false,
      defaultCountry: 'auto',
      autoHideDialCode: true,
      autoFormat: true,
      autoPlaceholder: true
    });

    angularPromiseButtonsProvider.extendConfig({
      spinnerTpl: '<i class="fa fa-circle-o-notch"></i>',
      disableBtn: true,
      btnLoadingClass: 'fa-spin',
      addClassToCurrentBtnOnly: false,
      disableCurrentBtnOnly: false,
      minDuration: false,
      CLICK_EVENT: 'click',
      CLICK_ATTR: 'ngClick',
      SUBMIT_EVENT: 'submit',
      SUBMIT_ATTR: 'ngSubmit',
      BTN_SELECTOR: 'button'
    });
  }
})();

angular.module("accapp").run(["$templateCache", function($templateCache) {$templateCache.put("app/account/confirmEmail.html","<div class=container><div class=jumbotron><div class=\"row text-center\"><span ng-class=\"{\'glyphicon-thumbs-up\':!!confirmemail.valid, \'glyphicon-thumbs-down\':!confirmemail.valid}\" class=glyphicon style=\"font-size: 64px\"></span><h1>{{confirmemail.title}}</h1><p>{{confirmemail.subTitle}}</p><!--<a ng-if=\"confirmemail.valid\" href=\"#\" class=\"btn btn-success btn-lg\">Login</a>--></div></div></div>");
$templateCache.put("app/account/forgotPassword.html","<div class=container><div class=blank-row-100></div><div class=row><div class=\"col-md-4 col-md-offset-4\"><div class=\"panel panel-default\"><div class=panel-body><div class=text-center><h3><i class=\"fa fa-lock fa-4x\"></i></h3><h2 class=text-center>Forgot Password?</h2><p>You can reset your password here.</p><div class=panel-body><form class=form name=forgotPasswordForm ng-submit=forgotpassword.nextStep(forgotPasswordForm.$valid)><fieldset><div class=form-group><div class=input-group><span class=input-group-addon><i class=\"glyphicon glyphicon-envelope color-blue\"></i></span> <input id=emailInput placeholder=\"email address\" class=form-control type=email ng-model=forgotpassword.email oninvalid=\"setCustomValidity(\'Please enter a valid email address!\')\" onchange=\"try{setCustomValidity(\'\')}catch(e){}\" required></div></div><div class=form-group><button type=submit class=\"btn btn-lg btn-primary btn-block\">Next Step</button></div></fieldset></form><!--<a href=\"\" ng-click=\"\" >Try a different question?</a>--></div></div></div></div></div></div></div><!--\r\n    Get a verification code by text message at: (•••) •••-••63\r\n    Confirm the phone number you provided in your security settings: (•••) •••-••63\r\n-->");
$templateCache.put("app/account/myaccount.html","<div class=container><div id=loading-bar-container></div><div class=blank-row-25></div><div class=row><div class=col-sm-2><div class=text-center><img ng-click=myaccount.changePicture() class=\"user-img img-circle\" height=100px ng-attr-ng-src=\"{{myaccount.userInfo.user.profile.picture?myaccount.userInfo.user.profile.picture:\'/assets/images/user-picture.png\'}}\" alt=\"\"><div class=caption><a href=\"\" ng-click=myaccount.changePicture()>Change Picture</a></div></div></div><div class=\"col-sm-10 text-center\"><h1>{{myaccount.settings.preferredUsername}}</h1></div><!--<pre>{{myaccount.userInfo.user}}</pre>--></div><div class=row><div class=col-sm-3><!--left col--><ul class=list-group><li class=\"list-group-item text-muted\">Profile</li><li class=\"list-group-item text-right\"><span class=pull-left><strong>Joined</strong></span>{{myaccount.userInfo.user.profile.joindate* 1000 | date:\'MM-dd-yyyy HH:mm:ss\'}}</li><li class=\"list-group-item text-right\"><span class=pull-left><strong>Last seen</strong></span> Yesterday</li><li class=\"list-group-item text-right\"><span class=pull-left><strong>Real name</strong></span> {{myaccount.userInfo.user.profile.name}} {{myaccount.userInfo.user.profile.family_name}}</li></ul><div class=\"panel panel-default\"><div class=panel-heading>Website <i class=\"fa fa-link fa-1x\"></i></div><div class=panel-body><a href=https://blackstonemerchant.com/ >www.blackstonemerchant.com</a></div></div><!--<ul class=\"list-group\">\r\n        <li class=\"list-group-item text-muted\">Activity <i class=\"fa fa-dashboard fa-1x\"></i></li>\r\n        <li class=\"list-group-item text-right\"><span class=\"pull-left\"><strong>Shares</strong></span> 125</li>\r\n        <li class=\"list-group-item text-right\"><span class=\"pull-left\"><strong>Likes</strong></span> 13</li>\r\n        <li class=\"list-group-item text-right\"><span class=\"pull-left\"><strong>Posts</strong></span> 37</li>\r\n        <li class=\"list-group-item text-right\"><span class=\"pull-left\"><strong>Followers</strong></span> 78</li>\r\n      </ul>--><div class=\"panel panel-default\"><div class=panel-heading>Social Media</div><div class=panel-body><a href=https://www.facebook.com/blackstonemerchantservices target=_blank><i class=\"fa fa-facebook fa-2x\"></i></a> &nbsp <a href=https://twitter.com/blackstonems target=_blank><i class=\"fa fa-twitter fa-2x\"></i></a> &nbsp <a href=\"http://www.linkedin.com/company/blackstone-merchant-services-inc.?trk=fc_badge\" target=_blank><i class=\"fa fa-linkedin fa-2x\"></i></a> &nbsp <a href=https://instagram.com/blackstone_ms/ target=_blank><i class=\"fa fa-instagram fa-2x\"></i></a> &nbsp</div></div></div><!--/col-3--><div class=col-sm-9><uib-tabset active=active><uib-tab index=0 heading=Accounts><div class=blank-row-25></div><div class=row><div class=col-md-12><div class=\"btn btn-primary\" ng-click=myaccount.addAccount()>Add Account</div></div></div><div class=row><div class=\"col-md-4 col-md-offset-8\"><div class=\"btn-group pull-right\"><label class=\"btn btn-info\" ng-model=myaccount.accordionExpanded btn-radio=true ng-click=myaccount.toggleExpand(true)>Expand All</label><label class=\"btn btn-info\" ng-model=myaccount.accordionExpanded btn-radio=false ng-click=myaccount.toggleExpand(false)>Collapse All</label></div></div></div><div class=blank-row-25></div><uib-accordion close-others=false><div uib-accordion-group is-open=group.isOpen class=panel-default ng-repeat=\"group in myaccount.groups\"><uib-accordion-heading>{{group.type}}<i class=\"pull-right glyphicon\" ng-class=\"{\'glyphicon-chevron-down\': group.isOpen, \'glyphicon-chevron-right\': !group.isOpen}\"></i></uib-accordion-heading><table class=\"table table-hover\"><thead class=thead-inverse><tr><th></th><th>ID</th><th>Default</th><th></th></tr></thead><tbody><tr ng-repeat=\"account in group.accounts\"><td>{{$index+1}}</td><td>{{account.accountId}}</td><td><span><i ng-class=\"{\'glyphicon glyphicon-check\': !!account.isDefault, \'glyphicon glyphicon-unchecked\': !account.isDefault}\"></i></span></td><td><a ng-class=\"{\'disabled\':!!account.isDefault}\" class=\"btn btn-info\" ng-click=\"myaccount.setDefaultItem(group, account)\">Set Default</a> <a ng-class=\"{\'disabled\':!!account.isDefault}\" class=\"btn btn-danger\" ng-click=\"myaccount.deleteItem(group, account)\">Delete</a></td></tr></tbody></table></div></uib-accordion></uib-tab><!--<uib-tab index=\"1\" heading=\"Notifications\">\r\n          <div class=\"tab-pane active\" id=\"home\">\r\n            <h4>Recent Activity</h4>\r\n            <div class=\"table-responsive\">\r\n              <table class=\"table table-hover\">\r\n                <tbody>\r\n                  <tr>\r\n                    <td><i class=\"pull-right fa fa-edit\"></i> Today, 1:00 - Jeff Manzi liked your post.</td>\r\n                  </tr>\r\n                  <tr>\r\n                    <td><i class=\"pull-right fa fa-edit\"></i> Today, 12:23 - Mark Friendo liked and shared your post.</td>\r\n                  </tr>\r\n                  <tr>\r\n                    <td><i class=\"pull-right fa fa-edit\"></i> Today, 12:20 - You posted a new blog entry title \"Why social media\r\n                      is\".\r\n                    </td>\r\n                  </tr>\r\n                  <tr>\r\n                    <td><i class=\"pull-right fa fa-edit\"></i> Yesterday - Karen P. liked your post.</td>\r\n                  </tr>\r\n                  <tr>\r\n                    <td><i class=\"pull-right fa fa-edit\"></i> 2 Days Ago - Philip W. liked your post.</td>\r\n                  </tr>\r\n                  <tr>\r\n                    <td><i class=\"pull-right fa fa-edit\"></i> 2 Days Ago - Jeff Manzi liked your post.</td>\r\n                  </tr>\r\n                </tbody>\r\n              </table>\r\n            </div>\r\n\r\n          </div>\r\n\r\n        </uib-tab>--><uib-tab index=1 heading=Settings><div class=tab-pane id=settings><form class=form name=registrationForm ng-submit=myaccount.update(registrationForm.$valid)><div class=form-group><div class=col-xs-6><label for=first_name><h4>First name</h4></label><input type=text class=form-control name=first_name id=first_name ng-model=myaccount.settings.name placeholder=First title=\"enter your first name if any.\"></div></div><div class=form-group><div class=col-xs-6><label for=last_name><h4>Last name</h4></label><input type=text class=form-control name=last_name id=last_name ng-model=myaccount.settings.familyName placeholder=Last title=\"enter your last name if any.\"></div></div><!--Mobile--><!--<div class=\"col-xs-6\">\r\n                <div class=\"form-group\">\r\n\r\n                  <label><h4>Mobile phone</h4></label>\r\n                  <input type=\"tel\" name=\"mobile\" ng-model=\"myaccount.settings.phoneNumber\" required class=\"form-control\" intl-tel-input>\r\n\r\n\r\n                </div>\r\n                <div class=\"help-block\" role=\"alert\" ng-messages=\"registrationForm.mobile.$error\" ng-show=\"registrationForm.mobile.$touched && registrationForm.mobile.$error.phoneNumber\">\r\n                  <span ng-message=\"phoneNumber\">Hmm, the mobile number dosn\'t look right</span>\r\n                </div>\r\n              </div>--><!--<div class=\"form-group\">\r\n                <div class=\"col-xs-6\">\r\n                  <label for=\"mobile\"><h4>Mobile</h4></label>\r\n                  <input type=\"text\" class=\"form-control\" name=\"mobile\" id=\"mobile\" ng-model=\"myaccount.settings.phoneNumber\" placeholder=\"enter mobile number\"\r\n                    title=\"enter your mobile number if any.\">\r\n                </div>\r\n              </div>--><!--<div class=\"form-group\">\r\n                <div class=\"col-xs-6\">\r\n                  <label for=\"email\"><h4>Email</h4></label>\r\n                  <input type=\"text\" class=\"form-control\" name=\"email\" id=\"email\" ng-model=\"myaccount.settings.email\" placeholder=\"you@email.com\"\r\n                    title=\"enter your email.\">\r\n                </div>\r\n              </div>--><div class=form-group><div class=col-xs-12><br><button type=submit ng-disabled=\"registrationForm.$pristine || registrationForm.$invalid\" class=\"btn btn btn-success\"><i class=\"glyphicon glyphicon-ok-sign\"></i> Update</button><!--<button ng-disabled=\"myaccount.busy\" class=\"btn btn\" type=\"reset\"><i class=\"glyphicon glyphicon-repeat\"></i> Reset</button>--></div></div></form></div></uib-tab></uib-tabset></div></div><!--/col-9--></div><!--/row-->");
$templateCache.put("app/account/passwordchanged.html","<div class=\"container text-center\"><div class=blank-row-50></div><div class=row><h1>Ready!</h1></div><div class=blank-row-25></div><div class=row><h1 class=\"fa fa-key fa-4x\"></h1></div><div class=row><h3>Your password has been reset successfully!</h3></div><div class=blank-row-100></div><div class=row><img src=https://blackstonemerchant.com/wp-content/uploads/2014/10/BMS-logo-e1414600879705.png alt=\"\"></div></div>");
$templateCache.put("app/account/resetPassword.html","<div class=container><div class=blank-row-100></div><div class=row><div class=\"col-md-4 col-md-offset-4\"><div class=\"panel panel-default\"><div class=panel-body><div class=text-center><h3><i class=\"fa fa-lock fa-4x\"></i></h3><h2 class=text-center>Reset your password</h2><p>Please enter your new password.</p><div class=panel-body><form class=form name=resetPasswordForm ng-submit=resetpassword.reset(resetPasswordForm.$valid)><fieldset><!--Password--><div class=form-group ng-class=\"{ \'has-error\': resetPasswordForm.password.$touched && resetPasswordForm.password.$invalid}\"><div class=input-group><span class=input-group-addon><i class=\"fa fa-key color-blue\"></i></span> <input type=password name=password ng-model=resetpassword.resetPasswordForm.password required ng-minlength=8 placeholder=Password class=form-control></div></div><div class=help-block role=alert ng-messages=resetPasswordForm.password.$error ng-show=resetPasswordForm.password.$touched><span ng-message=required>You can\'t leave this empty.</span></div><!--Confirm Password--><div class=form-group ng-class=\"{ \'has-error\': resetPasswordForm.confirmPassword.$touched && resetPasswordForm.confirmPassword.$invalid && resetPasswordForm.password.$valid}\"><div class=input-group><span class=input-group-addon><i class=\"fa fa-key color-blue\"></i></span> <input type=password name=confirmPassword ng-model=resetpassword.resetPasswordForm.confirmPassword required match=resetpassword.resetPasswordForm.password ng-minlength=8 placeholder=\"Confirm password\" class=form-control></div></div><div class=help-block role=alert ng-messages=resetPasswordForm.confirmPassword.$error ng-show=\"resetPasswordForm.confirmPassword.$touched && resetPasswordForm.password.$valid\"><span ng-message=required>You can\'t leave this empty.</span> <span ng-message=match>These passwords don\'t match. Try again?</span></div><div class=form-group><button type=submit class=\"btn btn-lg btn-primary btn-block\">Reset</button></div></fieldset></form><!--<a href=\"\" ng-click=\"\" >Try a different question?</a>--></div></div></div></div></div></div></div>");
$templateCache.put("app/account/resetpasswordemailsent.html","<div class=\"container text-center\"><div class=blank-row-50></div><div class=row><h1>Email Sent!</h1></div><div class=blank-row-25></div><div class=row><h1 class=\"glyphicon glyphicon-envelope\"></h1></div><div class=row><h3>Reset password link sent to {{resetpasswordemailsent.email}}</h3></div><div class=blank-row-10></div><div class=row><div class=\"col-md-6 col-md-offset-3\"><p>Check your email and follow the intructions for reseting your password.</p></div></div><!--<div class=\"blank-row-25\"></div>--><!--<div class=\"row\">\r\n        <a ng-href=\"{{signupdone.redirecUrl}}\" class=\"btn btn-primary\">Continue to Login</a>\r\n    </div>--><div class=blank-row-100></div><div class=row><img src=https://blackstonemerchant.com/wp-content/uploads/2014/10/BMS-logo-e1414600879705.png alt=\"\"></div></div>");
$templateCache.put("app/account/signup.html","<div class=container><div class=\"row text-center\"><div class=col-md-12><h1>Create your Blackstone Account</h1></div></div><div class=blank-row-50></div><div class=row><div class=\"col-sm-6 col-md-6 text-center\"><div class=row><h4>One account is all you need</h4></div><div class=row><h5>One free account gets you into everything Blackstone.</h5></div><div class=row><img src=https://blackstonemerchant.com/wp-content/uploads/2014/10/BMS-logo-e1414600879705.png alt=\"\"></div><div class=blank-row-100></div><div class=row><h4>Take it all with you</h4></div><div class=row><h5>Switch between devices, and pick up wherever you left off.</h5></div><div class=row><img src=https://ssl.gstatic.com/accounts/signup/devices_1x.png alt=\"\"></div></div><div class=\"col-sm-6 col-md-6\"><div class=row><form name=signUpForm ng-submit=signup.submitSignupForm(signUpForm.$valid) novalidate><!--Name--><div class=row><div class=\"col-sm-6 form-group\" ng-class=\"{ \'has-error\': signUpForm.firstname.$touched && signUpForm.firstname.$invalid}\"><label>Name</label><input type=text name=firstname ng-model=signup.signupForm.name required placeholder=First class=form-control></div><div class=\"col-sm-6 form-group\" ng-class=\"{ \'has-error\': signUpForm.lastname.$touched && signUpForm.lastname.$invalid}\"><label>&nbsp</label><input type=text name=lastname ng-model=signup.signupForm.lastName required placeholder=Last class=form-control></div></div><div class=help-block role=alert ng-messages=signUpForm.firstname.$error ng-show=signUpForm.firstname.$touched><span ng-message=required>You can\'t leave this empty.</span></div><div class=help-block ng-messages=signUpForm.lastname.$error ng-show=signUpForm.lastname.$touched><span ng-message=required>You can\'t leave this empty.</span></div><!--Password--><div class=form-group ng-class=\"{ \'has-error\': signUpForm.password.$touched && signUpForm.password.$invalid}\"><label>Create a password</label><input type=password name=password ng-model=signup.signupForm.password required ng-minlength=8 min-strength=3 placeholder=\"\" class=form-control><p ng-if=signUpForm.password.$error.minStrength>The given Password is too weak!</p></div><div class=help-block role=alert ng-messages=signUpForm.password.$error ng-show=signUpForm.password.$touched><span ng-message=required>You can\'t leave this empty.</span> <span ng-message=minlength>Short passwords are easy to guess. Try one with at least 8 characters.</span></div><!--<pre>{{signUpForm.password | json}}</pre>\r\n                    <pre>{{signup.signupForm.password | json}}</pre>--><!--Confirm Password--><div class=form-group ng-class=\"{ \'has-error\': signUpForm.confirmPassword.$touched && signUpForm.confirmPassword.$invalid}\"><label>Confirm your password</label><input type=password name=confirmPassword ng-model=signup.signupForm.confirmPassword required match=signup.signupForm.password placeholder=\"\" class=form-control></div><div class=help-block role=alert ng-messages=signUpForm.confirmPassword.$error ng-show=signUpForm.confirmPassword.$touched><span ng-message=required>You can\'t leave this empty.</span> <span ng-message=match ng-if=signUpForm.password.$valid>These passwords don\'t match. Try again?</span></div><!--Birthdate--><div class=row><div class=\"col-sm-4 form-group\"><label>Birthdate</label><select type=month name=bdaymonth ng-model=signup.signupForm.birthdateMonth required class=form-control ng-options=\"month.id as month.name for month in signup.months\"><option value=\"\" disabled>Month</option></select></div><div class=\"col-sm-4 form-group\"><label>&nbsp</label><input type=number name=bday ng-model=signup.signupForm.birthdateDay ng-min=1 ng-max=31 required placeholder=Day class=form-control></div><div class=\"col-sm-4 form-group\" ng-class=\"{ \'has-error\': signUpForm.year.$touched && signUpForm.year.$invalid}\"><label>&nbsp</label><select type=number name=bdayyear ng-model=signup.signupForm.birthdateYear required class=form-control ng-options=\"year as year for year in signup.years\"><option value=\"\" disabled>Year</option><!--<option ng-repeat=\"year in signup.years\">{{year}}</option>--></select><!--<input type=\"number\" name=\"bdayyear\" ng-model=\"signup.signupForm.birthdateYear\" ng-min=\"1920\" required placeholder=\"Year\"\r\n                                class=\"form-control\">--></div></div><div class=help-block role=alert ng-messages=signUpForm.bdaymonth.$error ng-show=signUpForm.bdaymonth.$touched><span ng-message=required>Select a month.</span></div><div class=help-block ng-messages=signUpForm.bday.$error ng-show=signUpForm.bday.$touched><span ng-message=required>You can\'t leave this empty.</span> <span ng-message=min>Hmm, the date doesn\'t look right. Be sure to use your actual date of birth.</span> <span ng-message=max>Hmm, the date doesn\'t look right. Be sure to use your actual date of birth.</span></div><div class=help-block ng-messages=signUpForm.bdayyear.$error ng-show=signUpForm.bdayyear.$touched><span ng-message=required>You can\'t leave this empty.</span> <span ng-message=min>Hmm, the date doesn\'t look right. Be sure to use your actual date of birth.</span></div><!--Gender--><div ng-if=false class=form-group><label>Gender</label><select class=\"form-control selectpicker\" ng-model=signup.signupForm.gender required ng-options=\"gender.value as gender.name for gender in signup.genders\"><option value=\"\" disabled selected>I am...</option></select></div><!--Mobile--><div class=form-group><label>Mobile phone</label><input type=tel name=mobile ng-model=signup.signupForm.mobile required class=form-control intl-tel-input></div><div class=help-block role=alert ng-messages=signUpForm.mobile.$error ng-show=\"signUpForm.mobile.$touched && signUpForm.mobile.$error.phoneNumber\"><span ng-message=phoneNumber>Hmm, the mobile number dosn\'t look right</span></div><!--Email--><div class=\"form-group has-feedback\" ng-class=\"{ \'has-error\': signUpForm.email.$touched && signUpForm.email.$invalid}\"><label>Your current email address</label><input type=text name=email ng-model=signup.signupForm.email ng-pattern=signup.emailFormat wc-unique required placeholder=\"\" class=form-control> <i ng-show=\"signUpForm.email.$touched && signUpForm.email.$error && signUpForm.email.$error.unique\" class=\"form-control-feedback glyphicon glyphicon-alert\"></i> <i ng-show=\"signUpForm.email.$touched && signUpForm.email.$valid\" class=\"form-control-feedback glyphicon glyphicon-ok\"></i></div><div class=help-block role=alert ng-messages=signUpForm.email.$error ng-show=\"signUpForm.email.$touched && (signUpForm.email.$error.unique || signUpForm.email.$error.pattern)\"><span ng-message=pattern>Invalid Email Format</span> <span ng-message=unique>Email already in use</span></div><!--Confirm Email--><div class=form-group ng-class=\"{ \'has-error\': signUpForm.confirmEmail.$touched && signUpForm.confirmEmail.$match}\"><label>Confirm your email address</label><input type=text name=confirmEmail ng-model=signup.signupForm.confirmEmail required match=signup.signupForm.email class=form-control></div><div class=help-block role=alert ng-messages=signUpForm.confirmEmail.$error ng-show=\"signUpForm.confirmEmail.$touched && signUpForm.confirmEmail.$error.match && !signUpForm.email.$error.unique\"><span ng-message=match>Email\'s dont match</span></div><button type=submit ng-disabled=signUpForm.$invalid class=\"btn btn-primary pull-right\">Create</button></form></div></div></div></div>");
$templateCache.put("app/account/signupdone.html","<div class=\"container text-center\"><div class=blank-row-50></div><div class=row><h1>Welcome!</h1></div><div class=blank-row-25></div><div class=row><h1 class=\"glyphicon glyphicon-envelope\"></h1></div><div class=row><h3>Confirmation email sent to {{signupdone.email}}</h3></div><div class=blank-row-10></div><div class=row><div class=\"col-md-6 col-md-offset-3\"><p>Thanks for creating a Blackstone Account. Use it to join our prepaid and merchant services, use our virtual office, and lots more.</p></div></div><div class=blank-row-25></div><div class=row><a ng-href={{signupdone.redirecUrl}} class=\"btn btn-primary\">Continue to Login</a></div><div class=blank-row-100></div><div class=row><img src=https://blackstonemerchant.com/wp-content/uploads/2014/10/BMS-logo-e1414600879705.png alt=\"\"></div></div>");
$templateCache.put("app/help/help.html","<h1>Help Page</h1><div ng-click=help.toggleSidebar() class=\"btn btn-primary\">Toggle Sidebar</div>");
$templateCache.put("app/home/home.html","<div class=\"jumbotron text-center\"><h1>\'Blackstone Accounts\'</h1></div>");
$templateCache.put("app/profile/profile.html","<h2>Profile Content</h2>");
$templateCache.put("app/shared/layout.default.html","<div class=container-fluid><div ui-view=header></div><div ui-view></div></div><div ui-view=footer></div>");
$templateCache.put("app/shared/layout.sidebar.html","<div class=container-fluid><div ui-view=header></div><div class=container-fluid><div class=row><div ng-show=toggleSidebar class=\"col-sm-3 col-md-2 sidebar\" ui-view=sidebar></div><div ng-class=\"{\'col-sm-9 col-sm-offset-3 col-md-10 col-md-offset-2\' : toggleSidebar,\'col-sm-12 col-md-12 main-full\': !toggleSidebar}\" class=main ui-view></div></div></div></div><div ui-view=footer></div>");
$templateCache.put("app/account/link-account-modal/link-account-modal.html","<div class=modal-header><h3 class=modal-title id=modal-title>Add Account</h3></div><div class=modal-body id=modal-body><div class=row><div class=col-md-12><uib-progressbar class=\"progress active\" max=2 value=vm.activeTab type=success><i>Step {{vm.activeTab}} / 2</i></uib-progressbar></div></div><div class=row><div class=col-md-12><uib-tabset active=vm.activeTab type=pills><uib-tab index=1 disable=true heading=\"Link Account\"><div class=row><div class=col-md-12><h3>Enter your Blackstone Agent Code bellow:</h3><p>You can find the 4 digit agent code in your welcome letter.</p></div></div><form id=stepOneForm name=stepOneForm ng-submit=vm.stepOneNext(stepOneForm.$valid) novalidate><div class=row><div class=\"form-group col-md-offset-0 col-md-6 col-sm-offset-2 col-sm-8 col-xs-offset-1 col-xs-10\"><div class=input-group><span class=input-group-addon><i class=\"fa fa-plug fa-fw\"></i></span> <input type=text name=number required ng-model=vm.id class=form-control placeholder=Number></div><div class=help-block role=alert ng-messages=stepOneForm.number.$error ng-show=stepOneForm.number.$touched><span ng-message=required>You can\'t leave this empty.</span></div></div><div class=\"form-group col-md-offset-0 col-md-6 col-sm-offset-2 col-sm-8 col-xs-offset-1 col-xs-10\"><div class=input-group><span class=input-group-addon><i class=\"fa fa-key fa-fw\"></i></span> <input type={{vm.inputType}} ng-init=\"vm.inputType = \'password\'\" name=password required ng-model=vm.password class=form-control placeholder=Password> <span ng-mousedown=\"vm.inputType = \'text\'\" ng-mouseleave=\"vm.inputType = \'password\'\" ng-mouseup=\"vm.inputType = \'password\'\" class=\"btn input-group-addon\" style=\"background-color: transparent\"><i class=\"fa fa-eye fa-fw\"></i></span></div><div class=help-block role=alert ng-messages=stepOneForm.$error ng-show=stepOneForm.password.$touched><span ng-message=required>You can\'t leave this empty.</span></div></div></div></form><div class=row><div class=col-md-12><a href=\"\">Need Help?</a></div></div></uib-tab><!--<uib-tab index=\"2\" disable=\'true\' heading=\"Step 2\">\r\n          <div class=\"row\">\r\n            <div class=\"col-md-12\">\r\n              <h2>Select</h2>\r\n              <p>You\'re almost there!, one more step to complete your registration.\r\n                <p>\r\n            </div>\r\n          </div>\r\n          <div class=\"row\">\r\n            <div ng-if=\"vm.anyOfType(vm.bsAccounts, 1)\" class=\"form-group col-sm-4 col-md-4 col-xs-4\">\r\n              <h4>Prepaid Accounts</h4>\r\n              <ul class=\"list-unstyled\">\r\n                <li ng-if=\'account.type==1\' ng-repeat=\'account in vm.bsAccounts\'>\r\n                  <div class=\"checkbox\">\r\n                    <label>\r\n                      <input type=\"checkbox\" ng-init=\'account.selected = true\' ng-model=\"account.selected\" ng-change=\"vm.toogleCheckBox(account)\">{{account.name}} ({{account.id}})\r\n                    </label>\r\n                  </div>\r\n                </li>\r\n              </ul>\r\n            </div>\r\n            <div ng-if=\"vm.anyOfType(vm.bsAccounts, 2)\" class=\"form-group col-sm-4 col-md-4 col-xs-4\">\r\n              <h4>Merchant Service Accounts</h4>\r\n              <ul class=\"list-unstyled\">\r\n                <li ng-if=\'account.type==2\' ng-repeat=\'account in vm.bsAccounts\'>\r\n                  <div class=\"checkbox\">\r\n                    <label>\r\n                      <input type=\"checkbox\" ng-init=\'account.selected = true\' ng-model=\"account.selected\" ng-change=\"vm.toogleCheckBox(account)\">{{account.name}} ({{account.id}})\r\n                    </label>\r\n                  </div>\r\n                </li>\r\n              </ul>\r\n            </div>\r\n            <div ng-if=\"vm.anyOfType(vm.bsAccounts, 3)\" class=\"form-group col-sm-4 col-md-4 col-xs-4\">\r\n              <h4>Calling Card Accounts</h4>\r\n              <ul class=\"list-unstyled\">\r\n                <li ng-if=\'account.type==3\' ng-repeat=\'account in vm.bsAccounts\'>\r\n                  <div class=\"checkbox\">\r\n                    <label>\r\n                      <input type=\"checkbox\" ng-init=\'account.selected = true\' ng-model=\"account.selected\" ng-change=\"vm.toogleCheckBox(account)\">{{account.name}} ({{account.id}})\r\n                    </label>\r\n                  </div>\r\n                </li>\r\n              </ul>\r\n            </div>\r\n\r\n          </div>\r\n          <div class=\"row\">\r\n            <div class=\"col-md-12\">\r\n              <div class=\"help-block\" role=\"alert\" ng-messages=\"vm.selectedBsAccounts.$error\">\r\n                <span ng-message=\"required\"><b>You have to select at least one account.</b></span>\r\n                <span ng-message=\"not-found\"><b>Account not found</b></span>\r\n              </div>\r\n            </div>\r\n          </div>\r\n        </uib-tab>--><uib-tab index=2 disable=true heading=Review><div class=row><div class=col-md-12><h3>Please check below:</h3><p>The following account(s) are going to be linked to your profile</p><p><b></b></p><div ng-if=\"vm.anyOfType(vm.selectedBsAccounts, 1)\" class=\"form-group col-md-4 col-sm-6 col-xs-6\"><h4>Prepaid Accounts</h4><ul class=list-unstyled><li ng-if=\"account.type==1\" ng-repeat=\"account in vm.selectedBsAccounts\"><p class=text-info>{{account.name}} ({{account.id}})</p></li></ul></div><div ng-if=\"vm.anyOfType(vm.selectedBsAccounts, 2)\" class=\"form-group col-md-4 col-sm-6 col-xs-6\"><h4>Merchant Service Accounts</h4><ul class=list-unstyled><li ng-if=\"account.type==2\" ng-repeat=\"account in vm.selectedBsAccounts\"><p class=text-info>{{account.name}} ({{account.id}})</p></li></ul></div><div ng-if=\"vm.anyOfType(vm.selectedBsAccounts, 3)\" class=\"form-group col-sm-4 col-md-4 col-xs-4\"><h4>Calling Card Accounts</h4><ul class=list-unstyled><li ng-if=\"account.type==3\" ng-repeat=\"account in vm.selectedBsAccounts\"><p class=text-info>{{account.name}} ({{account.id}})</p></li></ul></div><!--<ul ng-if=\'vm.groups.length > 0\' class=\"list-unstyled\">\r\n                    <div class=\"row\">\r\n                      <div class=\"col-md-12\">\r\n                        <li ng-repeat=\'group in vm.groups\'>\r\n                          <div class=\"col-md-4\">\r\n                            <h4>{{group.type | accountType}} Accounts</h4>\r\n                            <ul ng-if=\"group.selectedTotal\" style=\"padding-left: 15px\" class=\"list-unstyled\">\r\n                              <li ng-if=\'account.selected\' ng-repeat=\'account in group.accounts\'>\r\n                                <p class=\"text-info\">{{account.name}} ({{account.id}})</p>\r\n                              </li>\r\n                            </ul>\r\n                            <div style=\"padding-left: 15px\" class=\'help-block\' ng-if=\"!group.selectedTotal\">No accounts of this type will be added</div>\r\n                          </div>\r\n                        </li>\r\n                      </div>\r\n                    </div>\r\n                  </ul>--></div></div></uib-tab></uib-tabset></div></div></div><div class=modal-footer><button class=\"btn btn-default pull-left\" type=button ng-click=vm.back()>Back</button> <button ng-if=\"vm.activeTab == 1\" class=\"btn btn-primary\" type=submit form=stepOneForm>Next</button><!--<button ng-if=\"vm.activeTab == 2\" class=\"btn btn-primary\" type=\"button\" ng-click=\"vm.stepTwoNext()\" ng-disabled=\'!vm.selectedBsAccounts.length\'>Next</button>--> <button ng-if=\"vm.activeTab == 2\" class=\"btn btn-success\" type=button ng-click=vm.stepThreeSubmit()>Finish</button> <button class=\"btn btn-warning\" type=button ng-click=vm.cancel()>Cancel</button></div>");
$templateCache.put("app/shared/templates/footer.tpl.html","<footer class=footer><div class=container><div class=\"text-muted clearfix\">Copyright © 2017 Blackstone Merchant Services. All Rights Reserved</div></div></footer>");
$templateCache.put("app/shared/templates/header.tpl.html","<nav class=\"navbar navbar-default navbar-fixed-top\"><div class=container><div class=navbar-header><button type=button ng-init=\"navCollapsed = true\" ng-click=\"navCollapsed = !navCollapsed\" class=\"navbar-toggle collapsed\" data-toggle=collapse aria-expanded=false><span class=sr-only>Toggle navigation</span> <span class=icon-bar></span> <span class=icon-bar></span> <span class=icon-bar></span></button> <a class=navbar-brand href=#><img alt=Brand height=30px src=https://blackstonemerchant.com/wp-content/uploads/2014/10/BMS-logo-e1414600879705.png></a></div><!-- Collect the nav links, forms, and other content for toggling --><div class=\"collapse navbar-collapse\" ng-class=\"{\'in\':!navCollapsed}\"><ul class=\"nav navbar-nav\"><li ui-sref-active=active><a ui-sref=root.home>Home </a></li><!--<li ng-class=\"{active:$state.includes(\'root.contacts\')}\" ><a ui-sref=\"root.contacts.list\">Contact</a></li>\r\n                <li ui-sref-active=\"active\"><a ui-sref=\"root.help\">Help</a></li>--></ul><ul class=\"nav navbar-nav navbar-right\"><li ng-if=!root.userInfo.isAuthenticated><a href=# class=navbar-link ui-sref=login>Login</a></li><li ng-if=root.userInfo.isAuthenticated uib-dropdown on-toggle=toggled(open)><a href id=nav-user-dropdown uib-dropdown-toggle><img ng-if=!!header.userInfo.user class=\"user-img img-circle navbar-user-img\" height=32px ng-attr-ng-src=\"{{header.userInfo.user.profile.picture?header.userInfo.user.profile.picture:\'/assets/images/user-picture.png\'}}\">&nbsp {{root.userInfo.user.profile.name}} &nbsp<span class=caret></span></a><ul class=dropdown-menu uib-dropdown-menu aria-labelledby=simple-dropdown><li ui-sref-active=active ng-repeat=\"item in header.profilemenu.items\"><a ui-sref={{item.state}}>{{item.name}}</a></li><li class=divider></li><li><a ui-sref=singout>Logout</a></li></ul></li></ul></div><!-- /.navbar-collapse --></div></nav>");
$templateCache.put("app/shared/templates/sidebar.tpl.html","<div class=sidebarCaption>My Sidebar Title<a href=\"\" class=\"hidden-xs pull-right glyphicon glyphicon-pushpin\"></a><hr></div><div class=container><div class=row><ul class=\"nav sidebar-nav\"><li ui-sref-active=active><a ui-sref=root.home>Home</a></li><li ui-sref-active=active><a ui-sref=root.contacts.list>Contacts</a></li><li ui-sref-active=active><a ui-sref=root.help>Help</a></li><li><hr></li><li ng-if=root.userInfo.isAuthenticated ui-sref-active=active><a ui-sref=root.profile>Profile</a></li><li ng-if=root.userInfo.isAuthenticated><a href=# ui-sref=signout>Logout</a></li><li ng-if=!root.userInfo.isAuthenticated><a href=# ui-sref=login>Login</a></li></ul></div></div>");
$templateCache.put("app/shared/modals/confirmModal/confirm-modal.html","<div class=modal-header><h2>{{vm.properties.title}}</h2></div><div class=modal-body>{{vm.properties.message}}</div><div class=modal-footer><button class=\"btn btn-primary\" ng-click=vm.ok()>{{vm.properties.buttons[0]}}</button> <button class=\"btn btn-default\" ng-click=vm.cancel()>{{vm.properties.buttons[1]}}</button></div>");
$templateCache.put("app/shared/modals/uploadImageModal/upload-image-modal.html","<div class=modal-header><h2>Upload Photo</h2></div><div class=modal-body><div class=row><div class=col-md-8><!--File Upload--><!--<div class=\"form-group\">\r\n        <div class=\"row\">\r\n          <div class=\"col-sm-6 col-md-12\">\r\n            <div class=\"thumbnail\">\r\n              <img src=\"\" ngf-thumbnail=\"vm.file\" ngf-size=\"{width: 500px, height: 500px, quality: 0.9}\">\r\n              <div class=\"caption\">\r\n                <a href=\"#\" class=\"btn btn-success\" name=\"file\" ngf-select=\"vm.uploadFile(vm.file)\" ng-model=\"vm.file\">Upload</a>\r\n              </div>\r\n            </div>\r\n          </div>\r\n        </div>\r\n      </div>--><form name=myForm novalidate><!--<button ngf-select ng-model=\"picFile\" accept=\"image/*\">\r\n            Select Picture</button>--><div ngf-select=\"uploadCtrl.enabledZone = false\" ngf-select-disabled=!uploadCtrl.enabledZone ng-init=\"uploadCtrl.enabledZone = true\" ngf-drop=\"uploadCtrl.enabledZone = false\" ngf-drag-over-class=\"\'dragover\'\" ng-model=picFile accept=image/* ngf-pattern=image/* class=cropArea><div ng-if=!uploadCtrl.enabledZone class=tools><div ng-click=uploadCtrl.removeFile() class=\"btn btn-danger btn-cancel\" title=Cancel><i class=\"glyphicon glyphicon-remove\"></i></div></div><p ng-if=uploadCtrl.enabledZone class=message>Drop your image or<br>click to add one</p><img-crop image=\"picFile  | ngfDataUrl\" result-image=croppedDataUrl ng-init=\"croppedDataUrl=\'\'\"></img-crop></div><span class=err ng-show=errorMsg>{{errorMsg}}</span></form></div><div class=col-md-4><div class=row><div class=\"text-center col-md-12\"><h4>Preview:</h4></div></div><div class=row><div class=\"text-center col-md-12\"><img class=img-thumbnail ng-src={{croppedDataUrl}}></div></div></div><!--<div class=\"col-md-6\">\r\n      <div>Select an image file: <input type=\"file\" id=\"fileInput\" onchange=\"angular.element(this).scope().uploadCtrl.handleFileSelect(this)\"/></div>\r\n      <div class=\"cropArea\">\r\n        <img-crop image=\"uploadCtrl.myImage\" result-image=\"uploadCtrl.myCroppedImage\"></img-crop>\r\n      </div>\r\n    </div>\r\n    <div class=\"col-md-6\">\r\n      <div>Cropped Image:</div>\r\n      <div><img ng-src=\"{{uploadCtrl.myCroppedImage}}\" /></div>\r\n    </div>--></div></div><div class=modal-footer><button class=\"btn btn-primary\" ng-disabled=!picFile ng-click=\"uploadCtrl.upload(croppedDataUrl, picFile.name)\">Ok</button> <button class=\"btn btn-default\" ng-click=uploadCtrl.cancel()>Cancel</button></div>");}]);